/**
 * useJobsIntegration Hook
 * 
 * Initializes the Jobs integration service to connect optimization events
 * to the unified Jobs system.
 */

import { useEffect } from 'react';
import { jobsIntegrationService } from '../../services/jobs/JobsIntegrationService';

export interface UseJobsIntegrationOptions {
    /**
     * Whether to automatically start the integration on mount
     * @default true
     */
    autoStart?: boolean;
}

/**
 * Hook to manage the Jobs integration service lifecycle
 */
export function useJobsIntegration(options: UseJobsIntegrationOptions = {}): void {
    const { autoStart = true } = options;

    useEffect(() => {
        if (!autoStart) {
            return;
        }

        // Only start if not already running
        if (!jobsIntegrationService.isRunning()) {
            jobsIntegrationService.start();
        }

        return () => {
            jobsIntegrationService.stop();
        };
    }, [autoStart]);
}
